/**
 * Dove deve trovarsi l'utente, dato lo stato della sessione.
 *
 * Una funzione pura, fuori da React, perché è la regola che governa tutti i
 * rimbalzi dell'applicazione e va potuta leggere e provare da sola. Prima era
 * una catena di `if` dentro `App.tsx`; con un router deve diventare un
 * indirizzo.
 *
 * L'ordine conta: i codici di recupero precedono qualunque altra cosa, perché
 * si mostrano una volta sola e l'utente deve dichiarare di averli salvati prima
 * di proseguire.
 */

import type { SessionStatus } from '../auth/authApi';
import { paths } from './routes';

/** Quel tanto di stato della sessione che decide la destinazione. */
export interface SessionPosition {
  /** Stato della sessione secondo il gateway. */
  status: SessionStatus;
  /** True se ci sono codici di recupero ancora da confermare. */
  hasPendingRecoveryCodes: boolean;
}

/**
 * Percorso a cui la sessione obbliga, oppure `null` se l'utente può stare
 * nell'area autenticata.
 *
 * @param position Stato della sessione.
 * @returns Il percorso obbligato, o `null` se nessuno lo è.
 */
export function requiredPath(position: SessionPosition): string | null {
  if (position.hasPendingRecoveryCodes) {
    return paths.recoveryCodes;
  }
  switch (position.status) {
    case 'pending_enrollment':
      return paths.mfaEnroll;
    case 'pending_mfa':
      return paths.mfaVerify;
    case 'anonymous':
      return paths.login;
    case 'active':
      return null;
  }
}
